export default "__VITE_ASSET__Czaf4LsP__"